import { Component, OnInit, OnDestroy } from '@angular/core';
import { TablaComponent } from '../../shared/components/tabla/tabla.component';
import { GithubService } from '../services/github-service.service';
import { ToolbarComponent } from '../../core/layout/components/toolbar/toolbar.component';
import { IFullProject } from '../models';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-gdl',
  imports: [TablaComponent, ToolbarComponent, CommonModule],
  templateUrl: './gdl.component.html',
  styleUrl: './gdl.component.scss',
})
export class GdlComponent implements OnInit, OnDestroy {
  /** Datos completos de proyectos para mostrar en tabla */
  demo: IFullProject[] = [];

  /** Indica si hay un refresh en background */
  isRefreshing = false;

  /** Indica si es la primera carga (mostrar loading completo) */
  isInitialLoading = true;

  private _refreshSubscription?: Subscription;

  constructor(readonly _githubService: GithubService) {}

  ngOnInit(): void {
    this.loadProjectData();
    this.subscribeToRefreshStatus();
  }

  ngOnDestroy(): void {
    this._refreshSubscription?.unsubscribe();
  }

  /**
   * Cargar datos de proyectos (con caché)
   *
   * @param forceRefresh - Forzar refresh ignorando caché
   */
  async loadProjectData(forceRefresh = false): Promise<void> {
    try {
      const result =
        await this._githubService.fetchCompleteProjectData(forceRefresh);

      this.demo = result.data;
      this.isInitialLoading = false;
    } catch (error) {
      console.error('❌ Error loading project data:', error);
      this.isInitialLoading = false;
    }
  }

  /**
   * Subscribe al estado de refreshing para UI
   */
  private subscribeToRefreshStatus(): void {
    this._refreshSubscription = this._githubService.isRefreshing$.subscribe(
      (isRefreshing) => {
        this.isRefreshing = isRefreshing;
      },
    );
  }

  /**
   * Método público para refresh manual (llamado desde template)
   */
  refreshData(): void {
    this.loadProjectData(true);
  }
}
